module.exports = __webpack_public_path__ + "static/media/PT.9bf52914.png";